var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88159)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.362305,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7758 0.362305H4.97578C2.32481 0.362305 0.175781 2.51134 0.175781 5.1623V31.5623C0.175781 34.2133 2.32481 36.3623 4.97578 36.3623H45.7758C48.4268 36.3623 50.5758 34.2133 50.5758 31.5623V5.1623C50.5758 2.51134 48.4268 0.362305 45.7758 0.362305Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5742 24.3623H50.5742V36.3623H14.5742V24.3623Z",
    fill: "#249F58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5759 0.362305H50.5759V12.3623H14.5759V0.362305ZM11.1583 9.72951C11.0263 9.92871 10.8751 10.1135 10.7023 10.2887C9.29349 11.6951 7.01349 11.6951 5.60949 10.2887C4.20309 8.88471 4.20309 6.6047 5.60949 5.20071C5.78229 5.02311 5.96949 4.8719 6.16869 4.7399C5.62869 5.7479 6.07269 7.3607 7.30629 8.5919C8.53989 9.8207 10.1503 10.2671 11.1607 9.72711L11.1583 9.72951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99459 9.73081C6.12659 9.93001 6.27779 10.1148 6.45059 10.29C7.85939 11.6964 10.1394 11.6964 11.5434 10.29C12.9498 8.88601 12.9498 6.60601 11.5434 5.20201C11.3706 5.02441 11.1834 4.87321 10.9842 4.74121C11.5242 5.74921 11.0802 7.36201 9.84659 8.59321C8.61299 9.82201 7.00259 10.2684 5.99219 9.72841L5.99459 9.73081Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88159"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.362305,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOman);
export default __webpack_public_path__ + "static/media/Oman.51ce40910b11cf6e6d937f3dcafe5316.svg";
export { ForwardRef as ReactComponent };